import { styled } from '@mui/material/styles';
import Watch from '../icons/Watch';
export const TimeIcon = styled(Watch)(({
  theme
}) => ({
  fill: theme.palette.grey[700],
  width: 24,
  height: 24
}));